module.exports = __webpack_public_path__ + "images/emoji/hocho.a2e40e12164afdff258e.png";